/* tslint:disable */
import { Link } from 'react-router-dom'
import { decorate, observable } from 'mobx'
import * as React from 'react'
import styled from 'styled-components'

import { Button } from '../../atoms/Button'
import { Content } from '../../atoms/Content/index'
import { Layout } from '../../atoms/Layout'
import { Nav } from '../../atoms/Nav'
import { ProfileDropdown } from '../../organisms/ProfileDropdown'
import Box from '../../atoms/Box'
import MenuStore from '../../stores/MenuStore'
import MobileMenu from '../../atoms/MobileMenu'
import cardBackground from './kidsHomeBackground.svg'
import { Query } from '@apollo/client/react/components'
import { GET_OWN_INTAKE_QUERY } from '../../queries/GET_OWN_INTAKE_QUERY'
import { withRouter } from 'react-router'
import { intakeMetrics } from '../../organisms/Intakes/intakeMetrics/calcIntakeMetrics'
// import {ReadButton} from "../../atoms/ReadButton";

// tslint:disable:max-line-length object-literal-sort-keys
const HomeImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

const Title = styled.h1`
  text-align: left !important;
  font-family: Nunito;
  font-weight: 900;
  font-size: 54px;
  color: #043E74;
`

const TextContainer = styled.div`
    padding-left: 20px;
    padding-right: 35%;
    position: relative;
    background: #C7F0F6;
    min-height: 500px;
    top: 20px;
    border-radius: 10px;
    padding-top: 30px;
    z-index: 1;
    box-shadow: 0 8px 40px 0 rgba(194, 111, 35, 0.2), 0 16px 80px 0 rgba(194, 111, 35, 0.2);
`

const P = styled.div`
  margin-top: 10px;
  font-size: 1rem;
  color: #043E74;
  text-align: left;
`
const translations = {
  'en': {
    kidsSpace: 'Kid’s Space',
    introduction: 'Now that you have completed the parent portion of WebTIPS, you and your  child can enter the Kid\'s Space - Web-T! This is a site made just for kids,  with movies, photos and games that will help your child to feel prepared  for their upcoming surgery. Billy Bot and his friend Tot Bot will guide your child through the Web-T experience!',
    intro2: 'Be sure to sit with your child while they explore the Kid\'s Space to  ensure that they access all of the information!',
    intro3: 'Click the \'Start\' button below to enter the Kid\'s WebTIPS Space.',
    start: 'START',
    activities: 'Activities',
    games: 'Games',
    tour: 'Tour',
    video: 'Video',
  },
  'es': {
    kidsSpace: 'Sitio de Niños',
    introduction: '¡Ahora que has terminado la porción de padres de WebTIPS, tú y tú hijo pueden entrar al Sitio de Niños, Web-T! Esta es una página hecha solo para niños. Esta página tiene películas, fotos, y juegos que ayudarán a preparar a tú hijo para su cirugía. ¡Billy Bot [Robot] y su amigo, Tot[o] Bot [Robot] guiará a tú hijo por L-Web-T!',
    intro2: '¡Asegúrate de sentarte con tú hijo mientras exploran el Sitio de Niños para asegurar que vean toda la información!',
    intro3: 'Haz clic en el botón de “Inicio” abajo para entrar a Sitio de Niños L-WebTIPS.',
    start: 'Inicio',
    activities: 'Actividades',
    games: 'Juegos',
    tour: 'Recorrido',
    video: 'Video',
  },
}

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

class HomePage extends React.Component {
  menuStore

  constructor (props) {
    super(props)
    this.menuStore = MenuStore.create({})
  }

  render () {
    return (
      <Layout hasKidBackground>
        <Nav.KidsBar>
          <Nav.KidsSite
            onClick={() => {
              this.menuStore.showMenu()
            }}
          />
          <Nav.KidsButton link="/kids-video" name="navBarVideo" text={`${translations[lang].video}`} />
          <Nav.KidsButton link="/kids-tour" name="navBarTourActive" text={`${translations[lang].tour}`} />
          <Nav.KidsButton link="/kids-games" name="navBarGames" text={`${translations[lang].games}`} />
          <Nav.KidsButton link="/kids-activities" name="navBarActivities" text={`${translations[lang].activities}`} />
          <ProfileDropdown color='#CEE3F9' />
        </Nav.KidsBar>
        <MobileMenu store={this.menuStore} />
        <Content>
          <div style={{ position: 'relative' }}>
            <TextContainer>
              <div style={{ position: 'relative', zIndex: 10 }}>
                <Title>{translations[lang].kidsSpace}</Title>
                <P>
                  {translations[lang].introduction}
                </P>
                <P>
                  {translations[lang].intro2}
                </P>
                <P>
                  {translations[lang].intro3}
                </P>
                <Link to={{
                  pathname: '/kids-video',
                  state: {
                    autoPlay: true
                  }
                }}>
                  <Button style={{ marginTop: 20 }}>{translations[lang].start}</Button>
                </Link>
              </div>

              <HomeImage id='image' src={cardBackground} alt='' />
              <Box h={20} />
            </TextContainer>

          </div>
          <Box h={20} />
        </Content>
      </Layout>
    )
  }
}

decorate(HomePage, {
  menuStore: observable
})

const KidsHomePage = withRouter(
  class Page extends React.Component {
    render () {
      return (
        <Query query={GET_OWN_INTAKE_QUERY}>{({ data, loading, error }) => {
          if (loading) { return null }
          if (error || !data || !data.getOwnIntake) { window.location.reload() }
          const intake = data.getOwnIntake
          const {
            section4ReviewCompleted
          } = intakeMetrics(intake)

          if (!section4ReviewCompleted) {
            this.props.history.replace('/kids-forbidden')
            return <div />
          }

          return (
            <HomePage />
          )
        }}
        </Query>
      )
    }
  }
)

export { KidsHomePage }



// WEBPACK FOOTER //
// ./src/pages/KidsHomePage/index.js